<div class="card">
    <form class="g-3" name="AllotmentForm" (ngSubmit)="Validate(AllotmentForm)" #AllotmentForm="ngForm">
        <div class="card-header">
            Asset Transfer
        </div>
        <div class="card-body">
            <div class="row pb-2">
                <div class="col-md-12 px-1">
                    <label class="form-font-label">Transfer Type</label>
                    <ul>
                        <li style="list-style:none;">
                            <input type="radio" name="AllotmentToType" (click)="Toggle('Location')"
                                [(ngModel)]="AssetAllotmentDetails.AllotmentToType" value="Location" />
                            <label class="form-font-label">Location</label> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" name="AllotmentToType" (click)="Toggle('Employee')"
                                [(ngModel)]="AssetAllotmentDetails.AllotmentToType" value="Employee" />
                            <label class="form-font-label">Employee</label> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type="radio" name="AllotmentToType"
                                [(ngModel)]="AssetAllotmentDetails.AllotmentToType" value="Return" />
                            <label class="form-font-label">Return</label> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </li>
                    </ul>
                    <div class="invalid-feedback">
                        Please select Assignment Date !
                    </div>
                </div>
            </div>
            <div class="row pb-2">
                <div class="col-md-4 px-1">
                    <label class="form-font-label">Assignment Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd MMM yyyy" name="AssignDate"
                            [(ngModel)]="AssetAllotmentDetails.AssignDate" ngbDatepicker #AssignDate="ngbDatepicker" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="AssignDate.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select Assignment Date !
                    </div>
                </div>
                <div class="col-md-4 px-1" *ngIf="!isShow">
                    <label class="form-font-label">Branch</label>
                    <ng-select name="AllotmentBranchId" [(ngModel)]="AssetAllotmentDetails.AllotmentBranchId"
                        #AllotmentBranchId="ngModel" placeholder="Select Branch">
                        <ng-option *ngFor="let branchdetail of Branch"
                            [value]="branchdetail.BranchMasterID">{{branchdetail.BranchName}}</ng-option>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select branch !
                    </div>
                </div>
                <div class="col-md-4 px-1" *ngIf="!isShow1">
                    <label class="form-font-label">Employee</label>

                    <ng-select name="AllotmentEmployeeId" [(ngModel)]="AssetAllotmentDetails.AllotmentEmployeeId"
                        #AllotmentEmployeeId="ngModel" placeholder="Select Employee">
                        <ng-option *ngFor="let emp of Employee" [value]="emp.EmpMasterid">{{emp.FullName}}</ng-option>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Employee !
                    </div>
                </div>
            </div>
            <div class="row pb-2">
                <div class="col-md-4 px-1">
                    <label class="form-font-label">Transfer Status</label>
                    <ng-select name="AllotmentStatus" [(ngModel)]="AssetAllotmentDetails.AllotmentStatus"
                        #AllotmentStatus="ngModel" placeholder="Select Allotment">

                        <ng-option *ngFor="let allotment of AllotmentType"
                            [value]="allotment.AllotmentName">{{allotment.AllotmentValue}}</ng-option>

                    </ng-select>
                    <div class="invalid-feedback">
                        Please select branch !
                    </div>
                </div>
                <div class="col-md-4 px-1">
                    <label class="form-font-label">Status</label>
                    <ng-select name="StatusId" [(ngModel)]="AssetAllotmentDetails.StatusId" #StatusId="ngModel"
                        placeholder="Select Status">
                        <ng-option *ngFor="let Statusdetail of Status"
                            [value]="Statusdetail.ESS_StatusMasterId">{{Statusdetail.StatusName}}</ng-option>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select branch !
                    </div>
                </div>
                <div class="col-md-4">
                    <label class="form-font-label">Attachment</label>
                    <Input id="contained-button-file" (change)="upload($event,'AssetAllotmentAttachment')"
                        name="Attachment" accept=".pdf,.jpg,.jpeg,.png" type="file" #Attachment
                        style="display: none;" />

                    <div class="col-12 ImageDiv" ngbTooltip="Only upload .pdf,.jpg,.jpeg,.png .">
                        <div class="upload-icon"
                            *ngIf="AssetAllotmentDetails.Attachment == null || AssetAllotmentDetails.Attachment == ''"
                            (click)="Attachment.click()">
                            <i class="bi bi-upload"></i>
                            <br />
                            <label>Upload</label>
                        </div>
                        <div ngbDropdown>
                            <label class="AssetImage" id="BasicPhoto"
                                *ngIf="AssetAllotmentDetails.Attachment != null && AssetAllotmentDetails.Attachment  != ''"
                                ngbDropdownToggle>{{AssetAllotmentDetails.Attachment}}</label>
                            <img *ngIf="AssetAllotmentDetails.Attachment != null && AssetAllotmentDetails.Attachment  != ''"
                                [src]="AssetAllotmentDetails.AttachmentUrl" class="AssetImage" ngbDropdownToggle
                                id="BasicPhoto" style="display: none;">

                            <div ngbDropdownMenu aria-labelledby="BasicPhoto">
                                <button ngbDropdownItem type="button"><a [href]="AssetAllotmentDetails.AttachmentUrl"
                                        target="_blank"><i class="bi bi-eye me-2"></i>View</a></button>
                                <button ngbDropdownItem type="button" (click)="Attachment.click()"><i
                                        class="bi bi-pencil-square me-2"></i>Edit</button>
                            </div>
                        </div>
                    </div>
                    <div class="invalid-feedback">
                        Please select image !
                    </div>
                </div>
                <!-- <div class="col-md-4 px-1">
                    <label class="form-font-label">Attachment</label>
                    <input class="form-control" type="file" id="formFile" name="Attachment"
                        [(ngModel)]="AssetAllotmentDetails.Attachment"
                        (change)="upload($event,'AssetAllotmentAttachment')" accept=".pdf,.jpg,.jpeg,.png">
                    <div class="invalid-feedback">
                        Please upload attachment!
                    </div>
                </div> -->
            </div>
            <div class="row pb-2">
                <div class="col-md-12 px-1">
                    <label class="form-font-label">Remark</label>
                    <input class="form-control" type="text" name="Remarks" #Remarks="ngModel"
                        [(ngModel)]="AssetAllotmentDetails.Remark" />
                    <div class="invalid-feedback">
                        Please select group !
                    </div>
                </div>

            </div>
            <div class="row pb-2">
                <div class="card-body p-1">

                    <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                        class="customeDatatable table table-bordered">
                        <thead class="table-light">
                            <tr>
                                <th scope="col" style="width: 5px; ">#</th>
                                <th scope="col">
                                    <input mdbCheckbox class="form-check-input" style="height: 15px; width: 15px;"
                                        name="header" type="checkbox" value="" />
                                </th>
                                <th scope="col" style="width: 200px; ">Asset Name </th>
                                <th scope="col" style="width: 200px; ">Asset Number </th>
                                <th scope="col" style="width: 200px;">Serial Number </th>
                                <th scope="col" style="width: 200px;display: none;">Branch id </th>
                                <th scope="col" style="width: 200px;">Manufacturer</th>
                                <th scope="col" style="width: 200px;">Model </th>
                                <th scope="col" style="width: 300px;">Warranty Expiry Date </th>
                                <th scope="col" style="width: 200px;">Cost</th>
                                <th scope="col" style="width: 200px;">Branch Name </th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let TableData of TableDatas; let i = index">
                                <th scope="row">{{i+1}}</th>
                                <td>
                                    <input mdbCheckbox class="form-check-input" name="row"
                                        style="height: 13px; width: 13px;" [(ngModel)]="TableData.isSelected"
                                        type="checkbox" value="" />
                                </td>
                                <td>{{TableData['AssetMasterName']}}</td>
                                <td>{{TableData['AssetNumber']}}</td>
                                <td>{{TableData['SerialNumber']}}</td>
                                <td style="display: none;">{{TableData['BranchId']}}</td>
                                <td>{{TableData['Manufacturer']}}</td>
                                <td>{{TableData['Model']}}</td>
                                <td>{{TableData['WarrantyExpiryDate'] | date: 'dd MMM yyyy'}}</td>
                                <td>{{TableData['Cost']}}</td>
                                <td>{{TableData['BranchName']}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>